<template>
  <b-overlay variant="transparent" :show="loading" rounded="sm">
    <div v-if="editServiceName">
      <b-form-input
        id="edit-service-name"
        class="service-name-input"
        v-model="serviceUserName"
        @blur="updateServiceUserName"
        @focus="onFocus"
        v-focus
        :state="serviceNameIsValid"
      />
      <b-form-invalid-feedback id="edit-service-name">
        {{ $t('enter-at-least-x-letters', { count: 3 }) }}
      </b-form-invalid-feedback>
    </div>
    <h5 v-else class="mb-3" @click="editServiceNameClicked">
      {{ serviceName }}
      <span
        v-if="isInstaller && service.user_name"
        class="text-small"
      >
        [{{ service.user_name }}]
      </span>
    </h5>
  </b-overlay>
</template>

<script>
import axios from 'axios';
import config from '@/config';
import { mapGetters, mapState, mapActions } from 'vuex';
import ToasterMixin from '@/mixins/Toaster';

export default {
  name: 'ServiceNameWithEditing',
  mixins: [
    ToasterMixin,
  ],
  props: {
    service: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      serviceUserName: '',
      editServiceName: false,
    };
  },
  computed: {
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    ...mapGetters([
      'getServiceName',
    ]),
    ...mapGetters({
      isInstaller: 'user/isUserInstaller',
      isSuperuser: 'user/isSuperuser',
    }),
    serviceName() {
      return this.getServiceName(this.service.id);
    },
    serviceNameIsValid() {
      return this.serviceUserName.replace(/\s/g, '').length >= 3 ? null : false;
    },
  },
  methods: {
    ...mapActions([
      'updateServices',
    ]),
    editServiceNameClicked() {
      if (this.isSuperuser) {
        this.editServiceName = true;
      }
    },
    async updateServiceUserName() {
      this.editServiceName = false;
      if (this.serviceName === this.serviceUserName || this.serviceNameIsValid === false) {
        return;
      }
      this.loading = true;
      const url = this.$backendUrl(
        config.ICOOL.API.SERVICE_PATH(this.currentSnapshot.id, this.service.id),
      );
      try {
        const response = await axios.patch(url, { user_name: this.serviceUserName });
        this.updateServices({ services: [response.data] });
        this.showToast(this.$t('edit-service-name'), this.$t('saved'), 'success');
      } catch (err) {
        this.$log.error(err);
        this.showToast(this.$t('edit-service-name'), this.$t('error'), 'danger');
      }
      this.loading = false;
    },
    onFocus() {
      this.serviceUserName = this.serviceName;
    },
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
};
</script>

<style scoped>
.service-name-input {
  text-align: center;
  font-size: 120%;
}
</style>
